import { Gauge, Percent, GraduationCap } from "lucide-react";
import { useTranslation } from 'react-i18next';


export default function FromIdea() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-[#FBFAF9]">
      {/* Верхнее сияние как на макете */}
      <div
        className="
          pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2
          w-[1400px] h-[260px]
          [background:radial-gradient(60%_120%_at_50%_0%,rgba(124,58,237,.35),rgba(124,58,237,.18)_40%,transparent_70%)]
          [mask-image:linear-gradient(to_bottom,white,white,transparent)]
        "
      />

      <div className="mx-auto px-[20px] sm:px-[100px] lg:px-[200px] pt-16 pb-10 lg:pt-24 lg:pb-16">
        {/* Заголовки */}
        <h1 className="text-center text-4xl sm:text-5xl font-extrabold leading-tight">
          <span className="bg-gradient-to-r from-purple-700 to-purple-400 bg-clip-text text-transparent">
            {t('$Header9')}
          </span>
        </h1>
        <p className="mt-2 text-center text-2xl sm:text-3xl font-extrabold text-gray-900">
          {t('$Header10')}
        </p>

        {/* Подзаголовок */}
        <p className="mt-6 max-w-3xl mx-auto text-center text-gray-500">
          {t('$Text5')}
        </p>

        {/* 3 колонки с преимуществами */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-[10rem] mx-auto">
          {/* Колонка 1 */}
          <div>
            <div className="flex items-center gap-3">
              <Gauge className="w-8 h-8" />
              <span className="text-sm font-semibold text-purple-600">
                {t('$Benefit1')}
              </span>
            </div>
            <h3 className="mt-3 text-lg font-bold text-gray-900">
              {t('$Subheader12')}
            </h3>
            <p className="mt-3 text-gray-600">
              {t('$Text6')}
            </p>
          </div>

          {/* Колонка 2 */}
          <div>
            <div className="flex items-center gap-3">
              <Percent className="w-8 h-8" />
              <span className="text-sm font-semibold text-purple-600">
                {t('$Benefit2')}
              </span>
            </div>
            <h3 className="mt-3 text-lg font-bold text-gray-900">
              {t('$Subheader13')}
            </h3>
            <p className="mt-3 text-gray-600">
              {t('$Text7')}
            </p>
          </div>

          {/* Колонка 3 */}
          <div>
            <div className="flex items-center gap-3">
              <GraduationCap className="w-8 h-8" />
              <span className="text-sm font-semibold text-purple-600">
                {t('$Benefit3')}
              </span>
            </div>
            <h3 className="mt-3 text-lg font-bold text-gray-900">
              {t('$Subheader14')}
            </h3>
            <p className="mt-3 text-gray-600">
              Используйте проверенные решения, чтобы команда училась на
              реальных кейсах и быстрее достигала результата — без проб и
              ошибок, свойственных теоретическим курсам.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
